export function regex(): string {
  return 'regex';
}

export const REGEX_ONLY_NUMBER = /^\d+$/;
